(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[662],{

/***/ 79655:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings",
      function () {
        return __webpack_require__(95642);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53399);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34745);
/* harmony import */ var src_components_Message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29143);








const ChangePassword = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const [password, setPassword] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [nwePassword, setNewPassword] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [confirmPassword, setConfirmPassword] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const changePassword = async ()=>{
        let text = "";
        if (password == "" || nwePassword == "" || confirmPassword == "") {
            text = t("form cannot be empty");
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_6__/* .messageInfo */ .B)(text);
            return;
        }
        if (nwePassword != confirmPassword) {
            text = t("The new password does not match");
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_6__/* .messageInfo */ .B)(text);
            return;
        }
        // 接口请求增加 try-catch 捕获，防止网络异常或服务端报错导致页面未捕获异常
        try {
            let result = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_3__.updatePassword)({
                currentPassword: password,
                newPassword: nwePassword
            });
            if ((result === null || result === void 0 ? void 0 : result.code) == 0) {
                (0,src_components_Message__WEBPACK_IMPORTED_MODULE_6__/* .messageInfo */ .B)(result.msg);
                setPassword("");
                setNewPassword("");
                setConfirmPassword("");
            } else {
                (0,src_components_Message__WEBPACK_IMPORTED_MODULE_6__/* .messageInfo */ .B)((result === null || result === void 0 ? void 0 : result.msg) || t("Operation failed"));
            }
        } catch (error) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            // 优先展示后端 error.message；本地加密失败才用 error.message（未发请求）
            const backendMsg = (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.error) === null || ref2 === void 0 ? void 0 : ref2.message) || (error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.msg) || (error === null || error === void 0 ? void 0 : (ref5 = error.response) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : ref6.message);
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_6__/* .messageInfo */ .B)(backendMsg || (error === null || error === void 0 ? void 0 : error.message) || t("Operation failed"));
        }
    };
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const title = t("Settings");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[24px] pb-[30px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-[#222222] text-[18px] text-center w-full font-[600]",
                    children: t("Change Password")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    className: "w-full h-[36px] text-[12px] bg-[#F4F5F6] rounded-[30px] px-[30px] mt-[22px] mb-[15px]",
                    type: "password",
                    placeholder: t("Current Password"),
                    value: password,
                    onChange: (e)=>{
                        setPassword(e.target.value);
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    className: "w-full h-[36px] text-[12px] bg-[#F4F5F6] rounded-[30px] px-[30px] mb-[15px]",
                    type: "password",
                    placeholder: t("New Password"),
                    value: nwePassword,
                    onChange: (e)=>{
                        setNewPassword(e.target.value);
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    className: "w-full h-[36px] text-[12px] bg-[#F4F5F6] rounded-[30px] px-[30px] mb-[18px]",
                    type: "password",
                    placeholder: t("Confirm Password"),
                    value: confirmPassword,
                    onChange: (e)=>{
                        setConfirmPassword(e.target.value);
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "w-full h-[42px] bg-[#FFCF55] rounded-[41px] text-[#1B1C2B] font-[600] ".concat(password && nwePassword && confirmPassword ? "" : "opacity-[0.6]"),
                    disabled: password && nwePassword && confirmPassword ? false : true,
                    onClick: changePassword,
                    children: t("Change")
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ChangePassword);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(79655); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);